'use client'

import { useReducer, ReactNode, useMemo, useRef } from 'react'

import { CatalogState } from '@marketplace-web/catalog/catalog-data'

import CatalogContext from './CatalogContext'
import { initialState } from './catalog-initial-state'
import { catalogReducer } from './reducers/catalogReducer'

type CatalogProviderProps = {
  children: ReactNode
  initialCatalogState: CatalogState
}

const CatalogProvider = ({ children, initialCatalogState }: CatalogProviderProps) => {
  const [state, dispatch] = useReducer(catalogReducer, initialCatalogState ?? initialState)

  // prevents request race condition
  const dynamicFilterRequestVersion = useRef(0)
  const pendingFacetsType = useRef<string | null>(null)
  const isFiltersFetching = useRef(false)

  const refs = useMemo(
    () => ({ dynamicFilterRequestVersion, pendingFacetsType, isFiltersFetching }),
    [],
  )

  const value = useMemo(() => ({ state, dispatch, refs }), [state, dispatch, refs])

  return <CatalogContext.Provider value={value}>{children}</CatalogContext.Provider>
}

export default CatalogProvider
